
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.039.62l.1.01a.778.778 0 01.065 1.526A6.233 6.233 0 001.566 8.23c.017 3.417 2.823 6.22 6.266 6.204a6.248 6.248 0 006.003-4.674.774.774 0 01.77-.585l.096.01a.744.744 0 01.097.022.769.769 0 01.552.963c-.848 3.31-3.809 5.69-7.245 5.823L7.84 16C3.535 16.02.022 12.517 0 8.239A7.816 7.816 0 015.832.644a.764.764 0 01.207-.023zm3.264 4.592l.126.001c.293.018.586.14.818.366.497.485.524 1.262.06 1.737a1.16 1.16 0 01-.668.338l-.124.012a1.279 1.279 0 01-.945-.367c-.496-.484-.523-1.262-.06-1.737.216-.221.5-.338.793-.35zm-.44-2.654l.242.01a4.5 4.5 0 012.83 1.275 4.484 4.484 0 011.363 3.036.667.667 0 01-.162.506.637.637 0 01-.49.213.698.698 0 01-.507-.223.719.719 0 01-.197-.51 3.066 3.066 0 00-.93-2.074 3.066 3.066 0 00-2.102-.878H8.9l-.1-.017a.719.719 0 01-.55-.667.646.646 0 01.604-.67l.008-.001zM8.742 0l.303.01a7.214 7.214 0 014.628 2.051c1.334 1.301 2.12 3.056 2.185 4.878a.65.65 0 01-.196.46.65.65 0 01-.46.18.713.713 0 01-.7-.645 5.784 5.784 0 00-1.754-3.925 5.778 5.778 0 00-3.96-1.654h-.007L8.68 1.34a.718.718 0 01-.56-.67.646.646 0 01.615-.67l.011.116L8.742 0z"}})])
          )
        }
      }
    